<template>
  <kye-dialog
    width="400px"
    title="组织树"
    :visible="value"
    :append-to-body="appendToBody"
    @opened="onOpen"
    @close="onClose">
    <dept-tree-search
      ref="deptTreeSearch"
      :auth="auth"
      :hasAllTreeAuth="hasAllTreeAuth"
      :fetchData="fetchData"
      :filterData="filterData"
      :formatResult="formatResult"
      :searchUrl="searchUrl"
      :searchParams="searchParams"
      :searchResultUrl="searchResultUrl"
      :axios="axios"
      :disabledCache="disabledCache"
      :fetchAxios="fetchAxios"
      :defaultExpandedKeys="defaultExpandedKeys"
      :defaultExpandAll="defaultExpandAll"
      :checkNodeSelect="checkNodeSelect"
      :historyId="historyId">
    </dept-tree-search>
    <template slot="footer">
      <el-checkbox v-if="containLeaf" v-model="checked" style="float:left;">是否包含子节点</el-checkbox>
      <el-button type="primary" hotkey="ctrl+s" :disabled="disabledToSave" @click="onSave">保存(S)</el-button>
      <el-button @click="onCancel">取消</el-button>
    </template>
  </kye-dialog>
</template>

<script>
  import DeptTreeSearch from './dept-tree-search.vue'
  import {
    getPosterity
  } from '../query-table/utils'

  export default {
    name: 'KyeDept',
    components: {
      DeptTreeSearch
    },
    props: {
      value: { // 显示/隐藏弹窗
        type: Boolean,
        required: true
      },
      containLeaf: { // 是否显示”是否包含子节点“
        type: Boolean,
        default: true
      },
      auth: { // 是否走权限api（包含白名单）
        type: Boolean,
        default: false
      },
      hasAllTreeAuth: { // 模糊搜索是否不走权限接口的数据，不替换原有树，仅做查找
        type: Boolean,
        default: false
      },
      accordion: { // 是否每次只打开一个同级树节点展开
        type: Boolean,
        default: true
      },
      posterity: { // 勾选“是否包含子节点”时，返回所有后代节点
        type: Boolean
      },
      fetchData: { // 请求数据
        type: Function
      },
      filterData: { // 过滤数据
        type: Function
      },
      formatResult: { // 过滤搜索数据
        type: Function
      },
      formatData: { // 过滤保存数据
        type: Function
      },
      searchUrl: { // 搜索框调用api
        type: String,
        default: ''
      },
      searchParams: { // 搜索框调用api参数
        type: Function
      },
      searchResultUrl: { // 搜索后获取tree数据调用api
        type: String,
        default: ''
      },
      axios: { // axios
        type: Object,
        default: () => ({})
      },
      disabledCache: { // 是否禁用缓存，如果为false，每次打开弹框时都调用接口
        type: Boolean,
        default: true
      },
      fetchAxios: { // 获取历史月份组织参数 { data: {bakMonth: '2020-01'}, ...其他属性为 http 方法第三个参数为对象时的属性，比如{cancel,log,axios} }
        type: Function
      },
      preloadDeptTree: { // 是否预加载组织树
        type: Boolean,
        default: true
      },
      disabledToSave: { // 是否禁用保存按钮
        type: Boolean,
        default: false
      },
      appendToBody: { // Dialog 弹窗是否挂载至根节点
        type: Boolean,
        default: false
      },
      defaultExpandedKeys: Array, // 默认展开项
      defaultExpandAll: Boolean, // 是否默认展开所有
      checkNodeSelect: Function, // 检查当前节点是否可被选择
      historyId: String // 配合输入框的历史记录功能, 实现xPath不能区分节点, 添加指定的historyId确认唯一性
    },
    data () {
      return {
        checked: true
      }
    },
    mounted () {
      this.preloadDeptTree && this.$bus.$emit('preload-dept-tree')
    },
    methods: {
      onOpen () {
        this.$nextTick(_ => {
          this.$refs.deptTreeSearch.initTree()
          // this.$refs.deptTreeSearch.focus()
        })
      },
      onSave () {
        const deptTreeSearch = this.$refs.deptTreeSearch
        let node = deptTreeSearch.getCurrentNode()
        if (node) {
          const deptMap = deptTreeSearch.deptMap || {}
          const authTree = deptTreeSearch.authTree || []
          let value = null
          let id = node.id
          if (!deptMap[id]) {
            return this.$message.warning('请先选择')
          }
          let ids = deptMap[id].children
          if (this.checked && ids) {
            if (this.posterity) {
              value = getPosterity(deptMap, [id], ids)
            } else {
              value = [id].concat(ids)
            }
          } else {
            value = [id]
          }
          // 格式化数据
          const originValue = value
          const formatData = this.formatData
          if (value && formatData) {
            value = formatData({ value, map: deptMap, tree: authTree })
          }
          let data = {
            value,
            originValue, // 未格式化之前的value
            node, // 选中节点
            leaf: this.checked, // 是否包含
            deptMap: deptMap, // 当前tree数据扁平化数据
            tree: authTree // tree
          }
          this.$emit('change', data)
          this.$emit('input', false)
        } else {
          this.$message.warning('请先选择')
        }
      },
      onClose () {
        this.$emit('input', false)
      },
      onCancel () {
        this.$emit('input', false)
        this.$emit('cancel')
      },
      setCheckedDept (id) {
        this.$nextTick(_ => {
          this.$refs.deptTreeSearch.setCheckedDept(id)
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/public/components/kye-dept/index.vue